import { useCallback, useEffect, useState } from 'react'

import { TENANT_IT } from 'shared/consts'
import { getEventHandler } from 'views/components/molecules/Pagination/helpers'
import scrollToTop from 'views/utils/scrollToTop'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

/**
 * This hook enables the loading state to show the spinner only in rebranding
 * Then it executes the event handler to change page
 * Stops the loading state if it was enabled
 */

export const usePaginationChangePage = ({
  handler,
  pageNum,
  scrollToTopAfterEvent,
}) => {
  const { tenant } = usePublicConfig()
  const isRebrandingEnabled = tenant === TENANT_IT

  const [loading, setLoading] = useState(false)

  const getEventHandlerAndStopLoading = useCallback(() => {
    getEventHandler(
      handler,
      pageNum,
      scrollToTopAfterEvent ? scrollToTop : null
    )
    setLoading(false)
  }, [handler, scrollToTopAfterEvent, pageNum])

  const onHandleChangePage = event => {
    if (typeof handler !== 'function') {
      return undefined
    }

    if (isRebrandingEnabled) {
      setLoading(true)
    } else {
      getEventHandler(
        handler,
        pageNum,
        scrollToTopAfterEvent ? scrollToTop : null
      )
    }

    event.preventDefault()
  }

  useEffect(() => {
    if (loading) {
      getEventHandlerAndStopLoading()
    }
  }, [loading, getEventHandlerAndStopLoading])

  return {
    onHandleChangePage,
    isLoadingAndIsRebranding: loading,
  }
}
